import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@mui/material';
import { action, observable, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import { IParametroSistema, IValidacaoParametro, parametroDefault, validacaoDefault } from '../../modelo/ParametroSistema';
import parametroSistemaService from '../../services/ParametroSistemaService';
import parametroUsuarioService from '../../services/ParametroUsuarioService';
import TabelaParametrosSistema from './TabelaParametrosSistema';
import './css/ParametroSistemaStyles.css';
import TopBarStore from '../../store/TopBarStore';
import MensagemStore from '../../store/MensagemStore';
import RouterStore from '../../store/RouterStore';
import { IParametrosUsuario } from '../../modelo/Parametros';
import TabelaParametrosGabinete from './TabelaParametrosGabinete';


export interface IPropsParametroGabinete {
    parametroParaExclusao?: IParametroSistema;
}


class ParametroGabinete extends React.Component<IPropsParametroGabinete> {

    private parametros: IParametroSistema[] = undefined;
    private parametrosUsuario: IParametrosUsuario[] = undefined;
    private parametro = parametroDefault;
    private validacaoParametro = validacaoDefault;
    private openModalExclusao = false;
    private openModalInclusaoEdicao = false;
    private parametroParaExclusao: IParametroSistema = undefined;
    private parametroSistemaService = parametroSistemaService;
    private parametroUsuarioService = parametroUsuarioService;

    constructor(props) {
        super(props);

        makeObservable<ParametroGabinete, "parametros" | "parametrosUsuario" | "parametro" | "validacaoParametro" | "openModalExclusao" | "openModalInclusaoEdicao" | "parametroParaExclusao" | "atualizarLista" | "atualizarParametrosUsuario" | "validarParametro" | "limpar" | "abrirModalInclusaoEdicao">(this, {
            parametros: observable,
            parametrosUsuario: observable,
            parametro: observable,
            validacaoParametro: observable,
            openModalExclusao: observable,
            openModalInclusaoEdicao: observable,
            parametroParaExclusao: observable,
            atualizarLista: action,
            atualizarParametrosUsuario: action,
            validarParametro: action,
            limpar: action,
            handleInputChange: action,
            carregarParametro: action,
            abrirModalInclusaoEdicao: action,
            selecionarParametroParaExclusao: action,
            closeModalExclusao: action,
            closeModalInclusaoEdicao: action
        });
    }

    componentDidMount() {
        this.carregarParametros();
    }

    async carregarParametros() {
        let parametros = await this.parametroSistemaService.todosParametros(); //carregar parametros de gabinete
        const parametrosUsuario = await this.parametroUsuarioService.todosParametros(); //carregar parametros de gabinete
        if (parametros) {
            parametros.sort((c1, c2) => {
                if (typeof (c1.dataUltimaAlteracao) === 'object') {
                    const data1 = moment(c1.dataUltimaAlteracao).format('DD/MM/YYYY HH:mm');
                    const data2 = moment(c2.dataUltimaAlteracao).format('DD/MM/YYYY HH:mm');
                    return data1.localeCompare(data2);
                } else {
                    return c1.dataUltimaAlteracao.localeCompare(c2.dataUltimaAlteracao);
                }
            });
        } else {
            parametros = [];
        }
        this.atualizarLista(parametros);
        this.atualizarParametrosUsuario(parametrosUsuario)
    }

    private atualizarLista(parametros: IParametroSistema[]) {
        this.parametros = parametros;
    }

    private atualizarParametrosUsuario(parametrosUsuario: IParametrosUsuario[]) {
        this.parametrosUsuario = parametrosUsuario;
    }

    private validarParametro(parametro: IParametroSistema): boolean {
        this.validacaoParametro = { nome: undefined, valor: undefined } as IValidacaoParametro;
        let validado = true;
        if (!this.validarPreenchimentoObrigatorio(parametro.nome)) {
            this.validacaoParametro.nome = 'Campo obrigatório';
            validado = false;
        }
        if (!this.validarPreenchimentoObrigatorio(parametro.valor)) {
            this.validacaoParametro.valor = 'Campo obrigatório';
            validado = false;
        }
        return validado;
    }

    private validarPreenchimentoObrigatorio(valor): boolean {
        return valor || valor.length > 0;
    }

    async salvarParametro() {
        try {
            if (this.validarParametro(this.parametro)) {
                await this.parametroSistemaService.salvar(this.parametro);
                MensagemStore.apresentarInformacao('Parâmetro salvo com sucesso');
                await this.carregarParametros();
                this.limpar();
                this.closeModalInclusaoEdicao();
            }
        } catch (error) {
            console.error('Erro ao salvar parâmetro. ', error);
            MensagemStore.apresentarErro(`Erro ao salvar parâmetro. ${error}`);
        }
    }

    private limpar() {
        this.parametro = parametroDefault;
        this.validacaoParametro = validacaoDefault;
    }

    handleDescricaoChange = (event) => {
        this.handleInputChange(event, 'descricao');
    }

    handleNomeChange = (event) => {
        this.handleInputChange(event, 'nome');
    }

    handleValorChange = (event) => {
        this.handleInputChange(event, 'valor');
    }

    handleInputChange(event, nomeCampo) {
        event.preventDefault();
        this.parametro[nomeCampo] = event.target.value;
    }

    carregarParametro(parametro: IParametroSistema): void {
        this.parametro = parametro;
        this.abrirModalInclusaoEdicao(true);
    }

    private abrirModalInclusaoEdicao(abrir: boolean) {
        this.openModalInclusaoEdicao = abrir;
    }

    async excluirParametro() {
        try {
            await this.parametroSistemaService.excluir(this.parametroParaExclusao);
            MensagemStore.apresentarInformacao('Parâmetro excluído com sucesso');
            await this.carregarParametros();
            this.closeModalExclusao();
        } catch (error) {
            console.error('Erro ao excluir parâmetro. ', error);
            MensagemStore.apresentarErro(`Erro ao excluir parâmetro. ${error}`);
        }
    }

    selecionarParametroParaExclusao(parametro: IParametroSistema): void {
        this.openModalExclusao = true;
        this.parametroParaExclusao = parametro;
    }

    closeModalExclusao() {
        this.openModalExclusao = false;
        this.parametroParaExclusao = undefined;
    }

    closeModalInclusaoEdicao() {
        this.limpar();
        this.openModalInclusaoEdicao = false;
    }

    irParaTelaPrincipal = () => {
        RouterStore.push('/telaPrincipal');
    }

    render() {
        return (
            <div className="fixa-altura">
                <div className="fixa-altura">
                    {this.renderTabelaParametros()}
                    <div className="bloco-botoes">
                        <Button id='botaoAdicionarParametro'
                            color="primary"
                            variant="contained"
                            onClick={() => this.abrirModalInclusaoEdicao(true)}
                            title={'Adicionar Parâmetro'}
                        >
                            Novo Parâmetro
                        </Button>
                        &nbsp;
                        <Button color="secondary"
                            variant="outlined"
                            onClick={this.irParaTelaPrincipal}
                            title={'Sair'}
                        >
                            Voltar
                        </Button>
                    </div>
                </div>
                {this.renderModalExclusao()}
                {this.renderModalInclusaoEdicao()}
            </div>
        );
    }

    renderTabelaParametros() {
        return (
            <div className="container altura-container">
                {this.parametros !== undefined ?
                    this.parametros.length > 0 ?
                        <TabelaParametrosSistema parametros={this.parametros}
                            editar={this.carregarParametro.bind(this)}
                            excluir={this.selecionarParametroParaExclusao.bind(this)}
                            abrirModalInclusaoEdicao={this.abrirModalInclusaoEdicao.bind(this)}
                            irParaTelaPrincipal={this.irParaTelaPrincipal.bind(this)}
                            titulo="Parâmetros do Gabinete"
                            />
                        :
                        <h4 className="texto-table-vazia">Não existem parâmetros</h4>
                    :
                    <span><CircularProgress size={40} thickness={2} /></span>
                }
            </div>
        );
    }

    renderModalExclusao() {
        return (
            <Dialog open={this.openModalExclusao}
                onClose={this.closeModalExclusao.bind(this)}>
                <DialogTitle>
                    Excluir Parâmetro do Sistema
                </DialogTitle>
                <DialogContent>
                    Tem certeza que deseja excluir o parâmetro do sistema?
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="secondary"
                        onClick={this.closeModalExclusao.bind(this)}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="primary"
                        onClick={this.excluirParametro.bind(this)}>
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    renderModalInclusaoEdicao() {
        return (
            <Dialog open={this.openModalInclusaoEdicao}
                onClose={this.closeModalInclusaoEdicao.bind(this)}>
                <DialogTitle>
                    {this.parametro.id === undefined ? 'Incluir Parâmetro do Sistema' : 'Editar Parâmetro do Sistema'}
                </DialogTitle>
                <DialogContent>
                    <div>
                        <TextField label='Nome' value={this.parametro.nome}
                            onChange={this.handleNomeChange}
                            style={{ marginRight: 12, verticalAlign: 'bottom' }}
                            fullWidth={true}
                            disabled={this.parametro.id !== undefined}
                            error={!!this.validacaoParametro.nome}
                        />
                        <TextField label='Descrição' value={this.parametro.descricao}
                            onChange={this.handleDescricaoChange}
                            style={{ marginRight: 12, verticalAlign: 'bottom' }}
                            fullWidth={true}
                        />
                        <TextField label='Valor' value={this.parametro.valor}
                            onChange={this.handleValorChange}
                            style={{ marginRight: 12, verticalAlign: 'bottom' }}
                            fullWidth={true}
                            error={!!this.validacaoParametro.valor}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="secondary"
                        onClick={this.closeModalInclusaoEdicao.bind(this)}>
                        Cancelar
                    </Button>
                    <Button variant="outlined" color="secondary"
                        onClick={this.limpar.bind(this)}>
                        Limpar
                    </Button>
                    <Button variant="contained" color="primary"
                        onClick={this.salvarParametro.bind(this)}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default observer(ParametroGabinete);
